import { useEffect } from "react";

declare global {
  interface Window {
    _hsq: any;
  }
}

function inIframe() {
  try {
    return window.self !== window.top;
  } catch (e) {
    return true;
  }
}

export const useInitHubspot = (accountId: string) => {
  useEffect(() => {
    if (inIframe()) {
      return;
    }
    const script = document.createElement("script");
    script.src = `https://js.hs-scripts.com/${accountId}.js`;
    script.async = true;
    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, [accountId]);
};

window._hsq = window._hsq = window._hsq || [];

export const hubspotIdentify = (email: string) => {
  window._hsq.push(["identify", { email }]);
};

export const hubspotTrackPageView = () => {
  const currentPath = window.location.pathname + window.location.search;
  window._hsq.push(["setPath", currentPath]);
  window._hsq.push(["trackPageView"]);
};

export const hubspotTrackEvent = (
  name: string,
  properties: Record<string, string | undefined>,
) => {
  window._hsq.push([
    "trackCustomBehavioralEvent",
    { name: name, properties: properties },
  ]);
};

export enum HubspotEventEnum {
  PROJECT_DOCUMENT_DOWNLOADED = "project_document_download",
  PROJECT_NOTIFICATION_SUBSCRIBED = "project_notification_subscribed",
  PROJECT_NOTIFICATION_UNSUBSCRIBED = "project_notification_unsubscribed",
  PROJECT_SIMULATION_DONE = "project_simulation_done",
  PROJECTS_COMPARISON_DONE = "projects_comparison_done",
}
